module.exports = __webpack_public_path__ + "static/media/encuesta.df973770.png";